import React from 'react';
import PropTypes from 'prop-types';
import { t, Trans } from '@lingui/macro';
import { P, RadioGroup } from '@decisiv/ui-components';

export default function AutoRetryFilter({ handleForm, currentValue }) {
  return (
    <>
      <P marginBottom={1}>
        <Trans>Automatic Retry</Trans>
      </P>
      <RadioGroup
        marginBottom={1}
        name="radio_auto_retry"
        items={[
          { label: t`Both`, value: 'Both' },
          {
            label: t`Enabled`,
            value: 'Automatic Retry Enabled',
          },
          {
            label: t`Disabled`,
            value: 'Automatic Retry Disabled',
          },
        ]}
        vertical
        value={currentValue}
        onChange={(e) => {
          handleForm({ event: e, field: 'autoRetry' });
        }}
      />
    </>
  );
}

AutoRetryFilter.propTypes = {
  handleForm: PropTypes.func.isRequired,
  currentValue: PropTypes.string.isRequired,
};
